export default {
  tag: "Lo Que Hacemos",
  title1: "¡Mantente en Regla!",
  title2: "Tu Gestor de Permisos",
  subtitle:
    "Desde la consultoría hasta la planificación de tu cocina, estamos aquí para ayudarte como operador de food truck a mantener el enfoque en tu negocio.",
  learnMore: "Más información",
  items: [
    {
      title: "Asistencia con Permisos",
      description:
        "Nos encargamos de todas las solicitudes, renovaciones y seguimiento de cumplimiento de permisos del Condado de Orange para que nunca pierdas una fecha límite.",
    },
    {
      title: "Cumplimiento Regulatorio",
      description:
        "Mantente al día con los códigos de salud, las regulaciones de seguridad contra incendios y las leyes de zonificación del Condado de Orange con nuestro servicio de monitoreo de cumplimiento.",
    },
    {
      title: "Operación Estándar MFF",
      description:
        "Conéctate con cocinas comisaría certificadas y fabricantes de food trucks especializados en equipamiento aprobado por el Condado de Orange.",
    },
  ],
};